import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApmSidebarContentComponent } from './components/sidebar-content/sidebar-content.component';
import { ApmSidebarFooterComponent } from './components/sidebar-footer/sidebar-footer.component';
import { ApmSidebarComponent } from './components/sidebar/sidebar.component';

@NgModule({
  declarations: [ApmSidebarComponent, ApmSidebarContentComponent, ApmSidebarFooterComponent],
  imports: [CommonModule],
  exports: [ApmSidebarComponent, ApmSidebarContentComponent, ApmSidebarFooterComponent],
})
export class ApmSidebarModule {}
